import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "h-100",
  style: {"background-color":"#ffffff"}
}
const _hoisted_2 = {
  class: "right-div-adduser",
  style: {"margin-top":"10px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"60px","width":"85%"} }, [
  /*#__PURE__*/_createElementVNode("h3", null, "User Registration"),
  /*#__PURE__*/_createElementVNode("hr", { style: {"width":"80%","margin":"0 auto"} })
], -1 /* HOISTED */)
const _hoisted_4 = { id: "adduser-div" }
const _hoisted_5 = {
  id: "addusertbl",
  style: {"border":"none"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right","width":"25%"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "userId",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Employee Number "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_7 = { style: {"width":"30%","text-align":"left"} }
const _hoisted_8 = { style: {"text-align":"left","color":"red"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "12",
  style: {"width":"30%","text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("label", { style: {"color":"red","font-size":"90%"} }, "SMC employee / representative is requested to type 6 digit employee number at SMC head office.")
], -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("tr", { style: {"height":"10px"} }, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right","width":"25%"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "givenName",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Given Name "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_12 = { style: {"width":"25%","text-align":"left"} }
const _hoisted_13 = { style: {"text-align":"left","color":"red"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", { style: {"height":"10px"} }, null, -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right","width":"25%"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "familyName",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Family Name "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_17 = { style: {"width":"25%","text-align":"left"} }
const _hoisted_18 = { style: {"text-align":"left","color":"red"} }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("tr", { style: {"height":"10px"} }, null, -1 /* HOISTED */)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right","width":"25%"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "email",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("E-mail "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_22 = { style: {"width":"25%","text-align":"left"} }
const _hoisted_23 = { style: {"text-align":"left","color":"red"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("tr", { style: {"height":"10px"} }, null, -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right","width":"25%"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "title",
    style: {"margin-right":"8%"}
  }, [
    /*#__PURE__*/_createTextVNode("Station Code "),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_27 = { style: {"width":"25%","text-align":"left"} }
const _hoisted_28 = ["value"]
const _hoisted_29 = { style: {"text-align":"left","color":"red"} }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("tr", { style: {"height":"10px"} }, null, -1 /* HOISTED */)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right","width":"25%"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "department",
    style: {"margin-right":"8%"}
  }, "Title   ")
], -1 /* HOISTED */)
const _hoisted_33 = { style: {"width":"25%","text-align":"left"} }
const _hoisted_34 = { style: {"text-align":"left","color":"red"} }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("tr", { style: {"height":"10px"} }, null, -1 /* HOISTED */)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"right","width":"25%"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "deptCode",
    style: {"margin-right":"8%"}
  }, "Department   ")
], -1 /* HOISTED */)
const _hoisted_38 = {
  key: 0,
  style: {"width":"25%","text-align":"left"}
}
const _hoisted_39 = { style: {"text-align":"left","color":"red"} }
const _hoisted_40 = {
  key: 1,
  style: {"width":"25%","text-align":"left"}
}
const _hoisted_41 = ["value"]
const _hoisted_42 = { style: {"text-align":"left","color":"red"} }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */)
const _hoisted_44 = { style: {"width":"75%"} }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"50px","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "authoritySet",
    class: "col-sm-12 col-form-label",
    style: {"margin-left":"60px","margin-top":"10px"}
  }, [
    /*#__PURE__*/_createTextVNode(" Check the privacy notice "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      "data-bs-toggle": "modal",
      "data-bs-target": "#showEUModal"
    }, "(For GDPR countries)"),
    /*#__PURE__*/_createTextVNode(" /"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      "data-bs-toggle": "modal",
      "data-bs-target": "#showNonEUModal"
    }, "(For not GDPR countries)"),
    /*#__PURE__*/_createTextVNode(" before going to next page ")
  ])
], -1 /* HOISTED */)
const _hoisted_46 = { style: {"height":"50px","margin-left":"25px","margin-top":"10px","display":"block"} }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  for: "ds",
  style: {"margin-left":"10px","color":"#0d6efd","display":"inline"}
}, "Agree the privacy notice", -1 /* HOISTED */)
const _hoisted_48 = { style: {"margin-bottom":"5px"} }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<div class=\"modal fade\" id=\"showEUModal\" tabindex=\"-2\" aria-labelledby=\"showModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-scrollable modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"showModalLabel\">Privacy Notice</h5><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div><div class=\"modal-body\" id=\"modal-body\" style=\"width:100%;\"><p style=\"margin-left:25px;text-align:center;\"><span style=\"font-weight:bold;\">Privacy Notice for processing personal data</span></p><p style=\"margin-left:25px;text-align:right;\"> Suzuki Motor Corporation<br> 300 Takatsuka-cho, Minami-ku, Hamamatsu-shi,<br> Shizuoka-ken, Japan </p><p style=\"margin-left:5px;text-align:left;\"> Dear Sir/Madam,<br><br> Thank you very much for your cooperation with sales and after-sales services of Suzuki brand vehicles and their accessories and spare parts.<br> Below we set out our <span style=\"font-weight:bold;\">Privacy Notice</span>, which applies to the personal data which we collect from you for the purpose of your registration to and use of SCAN (Suzuki Computer Advanced Network) system and its necessary peripheral systems (collectively, <span style=\"font-weight:bold;\">“SCAN Systems”</span>) and management of your account on SCAN. </p><p style=\"margin-left:5px;text-align:right;\"> Sincerely yours,<br> Suzuki Motor Corporation </p><p style=\"margin-left:5px;text-align:center;\"><span style=\"font-weight:bold;\">Privacy Notice</span></p><p style=\"margin-left:5px;text-align:left;\"> &lt;Data Controller&gt;<br> Suzuki Motor Corporation (“SMC”) </p><p style=\"margin-left:5px;text-align:left;\"> &lt;No obligation&gt;<br> You are not obliged to provide your personal data, and there is no disadvantage to you save that you cannot use SCAN Systems if you decide not to provide them. </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Categories of Data&gt;<br> We will collect the following categories of Personal Data:<br> Employee Number, Given Name, Family Name, E-mail address, Department, Title, Station code (to identify your company), any data which you have submitted for previous SCAN systems, which includes; name, title, affiliation and data regarding privileges on previous SCAN systems </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Purposes&gt;<br> We process your personal data for the following purpose: </p><div style=\"text-align:left;\"><ul><li>to register you as the user of SCAN Systems</li><li>to make you use SCAN Systems</li><li>to manage your account on SCAN Systems</li></ul></div><p style=\"margin-left:5px;text-align:left;\"> We process your personal data for these purposes on the basis of legitimate interest.<br> We may also process your personal data where it is necessary for us to do so to comply with a legal obligation to which we are subject, or to establish, exercise or defend legal claims. </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Recipients&gt;<br> We will share your personal data with:<br> Service providers, Professional advisors<br><br> These recipients will process your personal data only for the above mentioned purposes.<br><br> We may also share personal data with any law enforcement agency, court, regulator or other third party, but only where it is necessary to comply with a legal obligation to which we are subject, or to establish, exercise or defend legal claims.<br><br> We may share your personal data with companies located in countries outside the European Economic Area which have not received certification from the European Commission of having adequate data protection laws in accordance with EU law. We do so when we have put in place appropriate safeguards (such as contractual commitments) to ensure that your personal data is adequately protected. For more information on these safeguards, please contact us using the details set out below. </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Retention of Personal Data&gt;<br> We will keep your personal data for a certain period after you provide it. When deciding how long to keep your personal data after this point, we take into account our legal obligations and regulators&#39; expectations, as well as the length of time we need it to fulfil the purposes set out above. </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Data Transfer to Japan&gt;<br> Your personal data will be received by us, SMC, which are located outside the European Economic Area, namely in Japan, which has already received certification from the European Commission of having adequate data protection laws in accordance with EU law. </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Contact points for data protection enquiries&gt;<br> You can access and make a request for the rectification, erasure or blocking of your personal data, request that we restrict our use of your personal data, or object to our use of your personal data by contacting us using the details set out below. If we are unable to resolve any concern you have about your personal data, you have the right to complain to your local data protection authority. </p><p style=\"margin-left:5px;text-align:left;\"> Suzuki Motor Corporation<br> 300 Takatsuka-cho, Minami-ku, Hamamatsu-shi,<br> Shizuoka-ken, Japan<br> E-mail: <a href=\"mailto:scanreg@hhq.suzuki.co.jp\">scanreg@hhq.suzuki.co.jp</a></p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-secondary\" data-bs-dismiss=\"modal\"> Close </button></div></div></div></div>", 1)
const _hoisted_51 = /*#__PURE__*/_createStaticVNode("<div class=\"modal fade\" id=\"showNonEUModal\" tabindex=\"-2\" aria-labelledby=\"showModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-scrollable modal-lg\"><div class=\"modal-content\"><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"showModalLabel\">Privacy Notice</h5><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div><div class=\"modal-body\" id=\"modal-body\" style=\"width:100%;\"><p style=\"margin-left:25px;text-align:center;\"><span style=\"font-weight:bold;\">Privacy Notice for processing personal data</span></p><p style=\"margin-left:25px;text-align:right;\"> Suzuki Motor Corporation<br> 300 Takatsuka-cho, Minami-ku, Hamamatsu-shi,<br> Shizuoka-ken, Japan </p><p style=\"margin-left:5px;text-align:left;\"> Dear Sir/Madam,<br><br> Thank you very much for your cooperation with sales and after-sales services of Suzuki brand vehicles and their accessories and spare parts.<br> Below we set out our <span style=\"font-weight:bold;\">Privacy Notice</span>, which applies to the personal data which we collect from you for the purpose of your registration to and use of SCAN (Suzuki Computer Advanced Network) and its necessary peripheral systems (collectively, <span style=\"font-weight:bold;\">“SCAN Systems”</span>) and management of your account on SCAN. </p><p style=\"margin-left:5px;text-align:right;\"> Sincerely yours,<br> Suzuki Motor Corporation </p><p style=\"margin-left:5px;text-align:center;\"><span style=\"font-weight:bold;\">Privacy Notice</span></p><p style=\"margin-left:5px;text-align:left;\"> &lt;Data Controller&gt;<br> Suzuki Motor Corporation (“SMC”) </p><p style=\"margin-left:5px;text-align:left;\"> &lt;No obligation&gt;<br> You are not obliged to provide your personal data, and there is no disadvantage to you save that you cannot use SCAN Systems if you decide not to provide them. </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Categories of Data&gt;<br> We will collect the following categories of Personal Data:<br> Employee Number, Given Name, Family Name, E-mail address, Department, Title, Station code (to identify your company), any data which you have submitted for previous SCAN systems, which includes; name, title, affiliation and data regarding privileges on previous SCAN systems </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Purposes&gt;<br> We process your personal data for the following purpose: </p><div style=\"text-align:left;\"><ul><li>to register you as the user of SCAN Systems</li><li>to make you use SCAN Systems</li><li>to manage your account on SCAN Systems</li></ul></div><p style=\"margin-left:5px;text-align:left;\"> We process your personal data for these purposes on the basis of legitimate interest.<br> We may also process your personal data where it is necessary for us to do so to comply with a legal obligation to which we are subject, or to establish, exercise or defend legal claims. </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Recipients&gt;<br> We will share your personal data with:<br> Service providers, Professional advisors<br><br> These recipients will process your personal data only for the above mentioned purposes. We may also share personal data with any law enforcement agency, court, regulator or other third party, but only where it is necessary to comply with a legal obligation to which we are subject, or to establish, exercise or defend legal claims. </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Retention of Personal Data&gt;<br> We will keep your personal data for a certain period after you provide it. When deciding how long to keep your personal data after this point, we take into account our legal obligations and regulators&#39; expectations, as well as the length of time we need it to fulfil the purposes set out above. </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Data Transfer to Japan&gt;<br> Your personal data will be received by us, SMC, which are located in Japan. </p><p style=\"margin-left:5px;text-align:left;\"> &lt;Contact points for data protection enquiries&gt;<br> You can access and make a request for the rectification, erasure or blocking of your personal data, request that we restrict our use of your personal data, or object to our use of your personal data by contacting us using the details set out below. If we are unable to resolve any concern you have about your personal data, you have the right to complain to your local data protection authority. </p><p style=\"margin-left:5px;text-align:left;\"> Suzuki Motor Corporation<br> 300 Takatsuka-cho, Minami-ku, Hamamatsu-shi,<br> Shizuoka-ken, Japan<br> E-mail: <a href=\"mailto:scanreg@hhq.suzuki.co.jp\">scanreg@hhq.suzuki.co.jp</a></p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-secondary\" data-bs-dismiss=\"modal\"> Close </button></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Navigation"]),
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("tr", null, [
            _hoisted_6,
            _createElementVNode("td", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                style: {"width":"95%","height":"38px"},
                id: "userId",
                maxlength: "6",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userId) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.userId]
              ]),
              _createElementVNode("span", _hoisted_8, _toDisplayString($setup.userIdError), 1 /* TEXT */)
            ]),
            _hoisted_9
          ]),
          _hoisted_10,
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("td", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                style: {"width":"95%","height":"38px"},
                id: "givenName",
                maxlength: "100",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.givenName) = $event)),
                onKeydown: _cache[2] || (_cache[2] = ($event: any) => ($setup.txtOnKeyDown($event))),
                onKeyup: _cache[3] || (_cache[3] = ($event: any) => ($setup.checkAlphabet($event))),
                onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.checkAlphabet($event)))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, $setup.givenName]
              ]),
              _createElementVNode("span", _hoisted_13, _toDisplayString($setup.givenNameError), 1 /* TEXT */)
            ]),
            _hoisted_14
          ]),
          _hoisted_15,
          _createElementVNode("tr", null, [
            _hoisted_16,
            _createElementVNode("td", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                style: {"width":"95%","height":"38px"},
                id: "familyName",
                maxlength: "100",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.familyName) = $event)),
                onKeydown: _cache[6] || (_cache[6] = ($event: any) => ($setup.txtOnKeyDown($event))),
                onKeyup: _cache[7] || (_cache[7] = ($event: any) => ($setup.checkAlphabet($event))),
                onChange: _cache[8] || (_cache[8] = ($event: any) => ($setup.checkAlphabet($event)))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, $setup.familyName]
              ]),
              _createElementVNode("span", _hoisted_18, _toDisplayString($setup.familyNameError), 1 /* TEXT */)
            ]),
            _hoisted_19
          ]),
          _hoisted_20,
          _createElementVNode("tr", null, [
            _hoisted_21,
            _createElementVNode("td", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                style: {"width":"95%","height":"38px"},
                id: "email",
                maxlength: "100",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.email) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.email]
              ]),
              _createElementVNode("span", _hoisted_23, _toDisplayString($setup.emailError), 1 /* TEXT */)
            ]),
            _hoisted_24
          ]),
          _hoisted_25,
          _createElementVNode("tr", null, [
            _hoisted_26,
            _createElementVNode("td", _hoisted_27, [
              _createElementVNode("input", {
                class: "form-control",
                style: {"text-transform":"uppercase","width":"95%","height":"38px"},
                id: "StationCode",
                maxlength: "4",
                onKeyup: _cache[10] || (_cache[10] = ($event: any) => ($setup.stationCodeChange($event))),
                value: $setup.StationCode
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_28),
              _createElementVNode("span", _hoisted_29, _toDisplayString($setup.stationError), 1 /* TEXT */)
            ]),
            _hoisted_30
          ]),
          _hoisted_31,
          _createElementVNode("tr", null, [
            _hoisted_32,
            _createElementVNode("td", _hoisted_33, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                style: {"width":"95%","height":"38px"},
                id: "title",
                maxlength: "100",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.title) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.title]
              ]),
              _createElementVNode("span", _hoisted_34, _toDisplayString($setup.titleError), 1 /* TEXT */)
            ]),
            _hoisted_35
          ]),
          _hoisted_36,
          _createElementVNode("tr", null, [
            _hoisted_37,
            ($setup.StationCode != '1000')
              ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    style: {"width":"95%","height":"38px"},
                    id: "deptCode",
                    maxlength: "100",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.deptCode) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.deptCode]
                  ]),
                  _createElementVNode("span", _hoisted_39, _toDisplayString($setup.deptError), 1 /* TEXT */)
                ]))
              : (_openBlock(), _createElementBlock("td", _hoisted_40, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select search-form-select",
                    style: {"width":"95%","height":"38px"},
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.selectedDept) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.departmentList, (department, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        class: "adjusting-option",
                        key: index,
                        value: department.group
                      }, _toDisplayString(department.group), 9 /* TEXT, PROPS */, _hoisted_41))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $setup.selectedDept]
                  ]),
                  _createElementVNode("span", _hoisted_42, _toDisplayString($setup.deptError), 1 /* TEXT */)
                ])),
            _hoisted_43
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.agreement) = $event)),
            style: {"display":"inline"},
            type: "checkbox",
            value: "agreement",
            name: "ds",
            id: "ds"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelCheckbox, $setup.agreement]
          ]),
          _hoisted_47
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("button", {
            disabled: !$setup.agreement,
            class: "btn btn-primary button-design",
            onClick: $setup.goToPage
          }, " Go to Permission Set ", 8 /* PROPS */, _hoisted_49)
        ])
      ])
    ]),
    _createCommentVNode(" Modal for EU"),
    _hoisted_50,
    _createCommentVNode(" Model End "),
    _createCommentVNode(" Modal for NonEU"),
    _hoisted_51,
    _createCommentVNode(" Model End ")
  ]))
}